import React, { useEffect, useRef, useState } from 'react';

export const DropdownAlertType = {
  Error: 'error',
  Success: 'success',
  Info: 'info',
  Warn: 'warn'
};

const colors = {
  error: { background: '#fef2f2', border: '#fecaca', title: '#b91c1c', text: '#991b1b' },
  success: { background: '#f0fdf4', border: '#bbf7d0', title: '#15803d', text: '#166534' },
  info: { background: '#eff6ff', border: '#bfdbfe', title: '#1d4ed8', text: '#1e40af' },
  warn: { background: '#fffbeb', border: '#fde68a', title: '#b45309', text: '#92400e' }
};

const DropdownAlert = ({ alert }) => {
  const [data, setData] = useState(null);
  const timer = useRef(null);
  const resolveAlert = useRef(null);

  useEffect(() => {
    if (!alert) return undefined;
    alert(
      (nextData) =>
        new Promise((resolve) => {
          if (timer.current) clearTimeout(timer.current);
          resolveAlert.current = resolve;
          setData(nextData);
          timer.current = setTimeout(() => {
            setData(null);
            resolveAlert.current?.();
            resolveAlert.current = null;
          }, nextData?.interval || 2000);
        })
    );
    return () => {
      if (timer.current) clearTimeout(timer.current);
      resolveAlert.current?.();
    };
  }, [alert]);

  if (!data) return null;
  const style = colors[data.type] || colors.info;
  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 100000,
        width: 'min(440px, calc(100vw - 32px))',
        padding: '12px 16px',
        borderRadius: 10,
        border: `1px solid ${style.border}`,
        background: style.background,
        boxShadow: '0 10px 25px rgba(15, 23, 42, 0.15)',
        fontFamily: 'Arial, sans-serif'
      }}>
      {!!data.title && <div style={{ marginBottom: data.message ? 3 : 0, color: style.title, fontSize: 14, fontWeight: 700 }}>{data.title}</div>}
      {!!data.message && <div style={{ color: style.text, fontSize: 14 }}>{data.message}</div>}
    </div>
  );
};

export default DropdownAlert;
